export const LIGHT_UP_QUESTION = `Some people light up a room without trying. That's not luck - that's communication.`
